import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {
    getOrderDataById,
    orderBulkUpdate,
    orderEasyUpdate
} from '../../../services/clinicPortalServices/orderEditService';
import { Autocomplete, TextField } from '@mui/material';
import { ModalStyled } from '../../../theme/customizedStyleComponents';
import { individualTestStatuses } from '../../../services/common/optionsData';
import toastr from 'toastr';

export default class OrderBulkStatusPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderDetails: null,
            status: ''
        };
    }

    componentDidMount() {
        this.setState({
            status: individualTestStatuses[0]
        });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSave = () => {
        const ids = this.props.selectedRows.map((row) => row._id);
        let params = {
            ids: this.props.selectedRows.map((row) => row._id),
            status: this.state.status
        };
        orderBulkUpdate(params).then((response) => {
            this.setState({
                status: individualTestStatuses[0]
            });
            this.props.loadGridData();
            this.props.handleClose();
        });
    };

    render() {
        return (
            <ModalStyled
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.props.show}
                onHide={this.props.handleClose}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Bulk Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 mt-4">
                            <Autocomplete
                                options={individualTestStatuses}
                                value={this.state.status}
                                onChange={(event, newValue) => {
                                    this.setState({
                                        status: newValue
                                    });
                                }}
                                getOptionLabel={(option) => (option ? option : '')}
                                renderInput={(params) => <TextField {...params} variant="outlined" label="Status *" />}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={this.handleSave}>
                        Save
                    </Button>
                </Modal.Footer>
            </ModalStyled>
        );
    }
}
